import blankProfile from "media/blank_profile.png";

import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

import IStore from "models/IStore";
import RoleEnum from "constants/RoleEnum";
import IUserCookieModel from "models/common-models/IUserCookieModel";

import "./ProfileMedia.css";

const ProfileMedia: React.FC = () => {
  const user: IUserCookieModel | null = useSelector((state: IStore) => state.auth.user);

  const [image, setImage] = useState<string | null>(null);
  const [name, setName] = useState<string | undefined>();

  const selectedProfileState: string | undefined = useSelector((state: IStore) => state.auth.selectedProfile);

  const nameFormatter = (name: string): string => {
    if (name.length > 30) {
      return name.substring(0, 30) + "...";
    }
    return name;
  };

  useEffect(() => {
    if (user) {
      if (selectedProfileState === RoleEnum.Actor) {
        setImage(user.avatar);
        setName(user.first_name);
      } else if (selectedProfileState === RoleEnum.CastAgency) {
        setImage(user.companies.cast_agency?.logo!);
        setName(user.companies.cast_agency?.name!);
      } else if (selectedProfileState === RoleEnum.ProductionCompany) {
        setImage(user.companies.production_company?.logo!);
        setName(user.companies.production_company?.name!);
      } else if (selectedProfileState === RoleEnum.Client) {
        setImage(user.companies.client?.logo!);
        setName(user.companies.client?.name!);
      } else {
        setImage(user.avatar);
        setName(user.first_name);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProfileState, user]);

  return (
    <span className="media profile-media">
      <span className="item-img">
        <img src={image || blankProfile} alt="Chat" />
      </span>
      <span className="media-body">
        <span className="item-title">{nameFormatter(name ?? "")}</span>
      </span>
    </span>
  );
};

export default ProfileMedia;
